import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const MarketplaceCreateApp = () => {
  const { t } = useTranslation();

  return (
    <div className="marketplace-create-app">
      <div className="inner">
        <div className="create-app">
          <div className="title">{t("marketplace.createApp.title")}</div>
          <div className="subtitle">{t("marketplace.createApp.subtitle")}</div>
          <a
            className="button"
            href="https://forum.authing.cn/c/5-category/22-category/22"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("marketplace.createApp.button")}
          </a>
        </div>
        <div className="doc-apn">
          <div className="title">{t("marketplace.apnDoc.title")}</div>
          <div className="subtitle">{t("marketplace.apnDoc.subtitle")}</div>
          <a
            className="button"
            href="https://docs.authing.cn/v2/apn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("marketplace.apnDoc.button")}
          </a>
        </div>
      </div>
    </div>
  );
};
